import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IDomainConceptProperty,
  IDomainConceptRelation,
} from 'Modules/Studio/constants/Domains/domains.interface';

type TTargetDomain = {
  name: string;
  id: string;
};
export interface IEditDomainConceptModalsState {
  isMoveConceptOpen: boolean;
  isMoveConceptWarningOpen: boolean;
  isMoveConceptNoAccessWarningOpen: boolean;

  targetDomain: TTargetDomain;

  isPropertyModalOpen: boolean;
  selectedProperty: IDomainConceptProperty | null;
  isRelationModalOpen: boolean;
  selectedRelation: IDomainConceptRelation | null;

  isInheritConceptOpen: boolean;

  // Future
  isRenameConceptModalOpen: boolean;
  isModifyDomainModalOpen: boolean;
  isDeleteDomainOpen: boolean;
}

export const initialState: IEditDomainConceptModalsState = {
  isMoveConceptOpen: false,
  isMoveConceptWarningOpen: false,
  isMoveConceptNoAccessWarningOpen: false,
  targetDomain: {
    name: '',
    id: '',
  },
  isRenameConceptModalOpen: false,
  isModifyDomainModalOpen: false,
  isDeleteDomainOpen: false,
  isPropertyModalOpen: false,
  selectedProperty: null,
  isRelationModalOpen: false,
  isInheritConceptOpen: false,
  selectedRelation: null,
};

export const editDomainConceptModals = {
  resetState: (state: IEditDomainConceptModalsState) => {
    state.isMoveConceptOpen = initialState.isMoveConceptOpen;
    state.isMoveConceptWarningOpen = initialState.isMoveConceptWarningOpen;
    state.isMoveConceptNoAccessWarningOpen = initialState.isMoveConceptNoAccessWarningOpen;
    state.targetDomain = {
      name: initialState.targetDomain.name,
      id: initialState.targetDomain.id,
    };

    state.isDeleteDomainOpen = initialState.isDeleteDomainOpen;
    state.isModifyDomainModalOpen = initialState.isModifyDomainModalOpen;
    state.isRenameConceptModalOpen = initialState.isRenameConceptModalOpen;
    state.isPropertyModalOpen = initialState.isPropertyModalOpen;
    state.selectedProperty = initialState.selectedProperty;
    state.isRelationModalOpen = initialState.isRelationModalOpen;
    state.selectedRelation = initialState.selectedRelation;
    state.isInheritConceptOpen = initialState.isInheritConceptOpen;
  },

  openRelationModal: (
    state: IEditDomainConceptModalsState,
    action: PayloadAction<IDomainConceptRelation | null>
  ) => {
    state.isRelationModalOpen = true;
    state.selectedRelation = action.payload;
  },

  closeRelationModal: (state: IEditDomainConceptModalsState) => {
    state.isRelationModalOpen = false;
    state.selectedRelation = null;
  },

  openPropertyModal: (
    state: IEditDomainConceptModalsState,
    action: PayloadAction<IDomainConceptProperty | null>
  ) => {
    state.isPropertyModalOpen = true;
    state.selectedProperty = action.payload;
  },

  closePropertyModal: (state: IEditDomainConceptModalsState) => {
    state.isPropertyModalOpen = false;
    state.selectedProperty = null;
  },

  openMoveConcept: (state: IEditDomainConceptModalsState) => {
    state.isMoveConceptOpen = true;
  },

  confirmMoveConcept: (
    state: IEditDomainConceptModalsState,
    action: PayloadAction<TTargetDomain>
  ) => {
    state.isMoveConceptWarningOpen = true;
    state.targetDomain = {
      name: action.payload.name,
      id: action.payload.id,
    };
  },

  closeMoveConceptWarningOnly: (state: IEditDomainConceptModalsState) => {
    state.isMoveConceptWarningOpen = initialState.isMoveConceptWarningOpen;
  },

  openNoAccessWarningModal: (state: IEditDomainConceptModalsState) => {
    state.isMoveConceptNoAccessWarningOpen = true;
  },

  openInheritConceptModal: (state: IEditDomainConceptModalsState) => {
    state.isInheritConceptOpen = true;
  },

  closeInheritConceptModal: (state: IEditDomainConceptModalsState) => {
    state.isInheritConceptOpen = false;
  },
};

export const editDomainConceptModalsSlice = createSlice({
  name: 'editDomainConceptModals',
  initialState: initialState,
  reducers: editDomainConceptModals,
});

export const {
  resetState,
  openMoveConcept,

  closeMoveConceptWarningOnly,
  confirmMoveConcept,
  openNoAccessWarningModal,

  openPropertyModal,
  closePropertyModal,
  openRelationModal,
  closeRelationModal,

  openInheritConceptModal,
  closeInheritConceptModal,
} = editDomainConceptModalsSlice.actions;

export default editDomainConceptModalsSlice.reducer;
